<mat-card>
 

  <!-- Description-->
  <mat-card-content>
    <div class="photo margin padding s5 top">
      <app-apps-photo
        [image]="app && app.logoUri"
        [app]="app"
        size="82px"
        aria-label="app-image"
      ></app-apps-photo>
    </div>
    <div class="mat-subtitle-1 margin padding s5 bottom top app-name">
      {{ app && app.name }}
    </div>
    @if (!app.description) {
    <div class="mat-body-2">
      {{ 'APP_DETAILS.default_description' | translate }}
    </div>
    }
    @if (app.description) {
    <div class="description mat-body-2">
      {{ app.description }}
    </div>
    }
  </mat-card-content>

  <!-- toogle -->
  <mat-card-actions align="start">
    <mat-slide-toggle
      color="primary"
      [checked]="isInternal"
      (change)="select($event)"
    >
      {{ 'Internal_Only' | translate }}
    </mat-slide-toggle>
  </mat-card-actions>
</mat-card>
